import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import BottomPanel from '../common/BottomPanel';
import Button from '../Button';
import { getUserFavoriteCinemas } from '../../reducers/user';
import { CinemaType } from '../../types/entities';
import styled from 'styled-components';
import AddFavCinemaSelector from '../CinemaSelector/AddFavCinemaSelector';
import { USER_FAV_CINEMA_ADD, USER_FAV_CINEMA_REMOVE, USER_FAV_CINEMAS_FETCH } from '../../actions/types';
import { PanelContainerProps } from '../common/RightSidePanel';

const List = styled.ul`
    font-size: 1.25rem;
    list-style: none;
    padding: 1rem 0;

    & > li {   
        cursor: pointer;
        margin-bottom: 0.75rem;
    }
`;

const FavIcon = styled.i`
    color: var(--primary);
    display: inline-block;
    margin-right: 1rem;
`;

interface Props {
    Container: React.ComponentType<PanelContainerProps>;
    cinemas: Array<CinemaType>;
    fetchFavCinemas: () => void;
    onAdd: (cinemaId: number) => void;
    onRemove: (cinemaId: number) => void;
    onClose: ({ hasChanged }? : { hasChanged: boolean }) => void;
}

const FavCinemasAddRemove: React.FC<Props> = (props) => {
    const [showAdd, setShowAdd] = React.useState(false);
    const [prevCinemas, setPrevCinemas] = React.useState<Array<CinemaType>>(props.cinemas);
    const [hasChanged, setHasChanged] = React.useState(false);
    const Container = props.Container || BottomPanel;
    
    useEffect(() => {
        props.fetchFavCinemas();
    }, []);

    useEffect(() => {
        const prevIds = prevCinemas.map(cinema => cinema.id).sort().join(',');
        const currentIds = props.cinemas.map(cinema => cinema.id).sort().join(',');
        setHasChanged(prevIds !== currentIds);
        setPrevCinemas(props.cinemas);
    }, [props.cinemas]);

    const onClose = () => {
        props.onClose({ hasChanged });
    };

    return (
        <>
            {!showAdd && <Container open onClose={onClose} title='Editar mis cines'>
                <FilterCinemasPanel
                    cinemas={props.cinemas}
                    onClose={onClose}
                    onAdd={setShowAdd}
                    onRemove={props.onRemove}
                />
            </Container>}
            {showAdd && <Container open onClose={() => setShowAdd(false)} title='Agregar cine'>
                <AddFavCinemaSelector
                    cinemaSelect
                    onAdd={props.onAdd}
                    onRemove={props.onRemove}
                    onClose={() => setShowAdd(false)}
                />
            </Container>}
        </>
    );
}

const FilterCinemasPanel: React.FC<{ cinemas: Array<CinemaType>, onClose: () => void, onAdd: (show: boolean) => void, onRemove: (cinemaId: number) => void }> = (props) => {
    return (
        <>
            {props.cinemas.length === 0
                ? <p>Aún no has agregado ningún cine a tus favoritos</p>
                : <div style={{ textAlign: 'left' }}>
                    <p>Para eliminar un cine, vuelve a tocar el corazón</p>
                    <List>
                        {props.cinemas.sort((a, b) => a.name.localeCompare(b.name)).map(cinema => <li key={cinema.id} onClick={() => props.onRemove(cinema.id)}>
                            <FavIcon className="fas fa-heart"></FavIcon>
                            {cinema.name}
                        </li>)}
                    </List>
                </div>
            }

            <Button block onClick={() => props.onAdd(true)}>Agregar cine</Button>
        </>
    );
}

const mapStateToProps = (state) => {
    return {
        cinemas: getUserFavoriteCinemas(state),
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        fetchFavCinemas: () => dispatch({ type: USER_FAV_CINEMAS_FETCH }),
        onAdd: (cinemaId: number) => dispatch({ type: USER_FAV_CINEMA_ADD, cinemaId }),
        onRemove: (cinemaId: number) => dispatch({ type: USER_FAV_CINEMA_REMOVE, cinemaId }),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(FavCinemasAddRemove);